/**
 * These are the possible error codes that an NetworkError can hold.
 */

export enum NetworkErrorCode {
  /** The server did not respond, e.g. it is 'down' (or there is no external network connection ). */
  NET_NO_RESPONSE = 'net::no-response',
  /** No internet connection
   * Note: we can't 100% reliable detect if internet connection is down.
   * https://stackoverflow.com/questions/189430/detect-the-internet-connection-is-offline
   * There is a risk of a false positive (internet connection ok) even though there is no
   * internet access. This happens if there is a access to a LAN (router) or virtual network.
   * In this case the error handling code Code will fall to 'conn::no-response' (= no response
   * from server).
   */
  NET_INTERNET_DISCONNECTED = 'net::internet-disconnected',
  /** No response from server within a time limit (as defined by the client code) */
  NET_REQUEST_TIMEOUT = 'net::request-timeout',
  /** Unknown network error */
  NET_UNKNOWN = 'net::unknown'
}
